import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleGuide from "@/pages/articles/superbuy-spreadsheet-guide/page";
import ArticleFinds from "@/pages/articles/superbuy-spreadsheet-finds/page";
import ArticleLinks from "@/pages/articles/superbuy-spreadsheet-links/page";
import ArticleQC from "@/pages/articles/superbuy-qc-guide/page";
import ArticleShoes from "@/pages/articles/superbuy-spreadsheet-shoes/page";
import ArticleHoodies from "@/pages/articles/superbuy-spreadsheet-hoodies/page";
import ArticleJackets from "@/pages/articles/superbuy-spreadsheet-jackets/page";
import ArticleBeginner from "@/pages/articles/superbuy-beginner-guide/page";
import ArticleSafety from "@/pages/articles/superbuy-spreadsheet-safety/page";
import ArticleShipping from "@/pages/articles/superbuy-shipping-guide/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/articles/superbuy-spreadsheet-guide", element: <ArticleGuide /> },
  { path: "/articles/superbuy-spreadsheet-finds", element: <ArticleFinds /> },
  { path: "/articles/superbuy-spreadsheet-links", element: <ArticleLinks /> },
  { path: "/articles/superbuy-qc-guide", element: <ArticleQC /> },
  { path: "/articles/superbuy-spreadsheet-shoes", element: <ArticleShoes /> },
  { path: "/articles/superbuy-spreadsheet-hoodies", element: <ArticleHoodies /> },
  { path: "/articles/superbuy-spreadsheet-jackets", element: <ArticleJackets /> },
  { path: "/articles/superbuy-beginner-guide", element: <ArticleBeginner /> },
  { path: "/articles/superbuy-spreadsheet-safety", element: <ArticleSafety /> },
  { path: "/articles/superbuy-shipping-guide", element: <ArticleShipping /> },
  { path: "*", element: <NotFound /> },
];

export default routes;